// The auth0 SDK can resolve to `undefined` (spa-js 2.27+); AppAuth coerces that
// to '' at the boundary so callers keep a plain string. No caller passes options.
type GetAccessTokenSilently = () => Promise<string>;
let getAccessTokenSilently: GetAccessTokenSilently;

export const sec = {
  getAccessTokenSilently: () => getAccessTokenSilently,
  setAccessTokenSilently: (func: GetAccessTokenSilently) => (getAccessTokenSilently = func)
};
